export default __webpack_public_path__ + "static/media/business_logo_placeholder.c1bd9a05.svg";